import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AUTOMATION_SCHEDULES_QUERY_KEY } from "./useFetchAutomationSchedules";

const deleteAutomationSchedule = async (id: string): Promise<void> => {
  await axios.delete(`${AUTOMATION_SERVICE_ADDRESS}/api/schedules/${id}`);
};

export default function useDeleteAutomationSchedule() {
  const queryClient = useQueryClient();

  return useMutation(deleteAutomationSchedule, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_SCHEDULES_QUERY_KEY);
    }
  });
}
